export function getPoiLogoUrl(logoS3: string | undefined): string | undefined {
  if (!logoS3) {
    return undefined;
  }
  return `${taptap.config.publicUrlBase}/brand-logos/${logoS3}.svg`;
}

export function getPoiImageUrl(poiId: string | undefined, iso3: string | undefined): string | undefined {
  if (!poiId || !iso3) {
    return undefined;
  }
  return `${taptap.config.publicUrlBase}/POIS/pro/images/${iso3.toLowerCase()}/${poiId}.jpg`;
}

export const openGoogleMaps = (venue: any) => {
  const lat = venue?.latlng?.lat || venue.lat;
  const lng = venue?.latlng?.lng || venue.lng;
  const name = venue?.name || '';
  const address = venue?.address || 'N/A';
  const pointType = venue?.point_type || '';
  if (lat === undefined || lng === undefined || lat === null || lng === null) {
    return;
  }
  const locationLabel = address !== 'N/A' ? address : `${lat}, ${lng}`;
  const searchTerm = [name || pointType, locationLabel].filter(Boolean).join(' ');
  const encodedSearch = encodeURIComponent(searchTerm);
  const url = `https://www.google.com/maps/search/${encodedSearch}/@${lat},${lng}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};
